/* eslint-disable no-unused-vars */
enum AppEvent {
    UPDATE_STATE = 'updateState',
}

export default AppEvent
